import { postalCodeRegex } from '@/shared/i18n/locales/pt-br/postalCode'

// [TODO] FID-1484 generalizar e implementar interface,
export function validatePostalCode(value) {
    if (!value) return true
    let justNumbers = value.replace(/[^\d]+/g,'')
    return postalCodeRegex.test(justNumbers)
}